import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import { Button } from '@components';
import { enviaAnexoComplementarRequest } from '@store/user/actions';
import { toast } from 'react-toastify';
import { AnexosPendentesForm } from './AnexosPendentes';
import { AnexosPendentesEmprestimoForm } from './AnexosPendentesEmprestimo';
import { RequerimentoService } from '../../../../../common/services/requerimento';

const AnexoPendenteModal = ({ requerimento }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [protocol, setProtocol] = useState('');
  const [anexoEnviado, setAnexoEnviado] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const formularios = useSelector((state) => state.requerimento.allFormsLabels);
  const formObj = formularios.find((valor) => {
    return valor.referencia === requerimento.Formulario;
  });

  function baixarArquivoPDF(protocolo) {
    try {
      const service = new RequerimentoService();
      setLoadingPDF(true);
      service
        .gerarPDFRequerimento({
          matricula: user.matricula,
          protocolo,
          token: user.token,
        })
        .then((res) => {
          const blob = new Blob([res], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Requerimento - ${protocolo}.PDF`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .finally(() => {
          setLoadingPDF(false);
        });
    } catch (error) {
      toast.error(`Erro ao gerar o PDF do requerimento`);
    }
  }

  return formObj ? (
    <>
      <div className="card mb-4">
        <div className="card-body card-desktop">
          <div>
            <Button
              onClick={() => baixarArquivoPDF(requerimento.Protocolo)}
              disabled={loadingPDF}
              className="simpleLink ts-14"
            >
              {loadingPDF ? 'Carregando...' : `Nº:${requerimento.Protocolo}`}
            </Button>
            <h1 className="ts-20 fw-bold">{formObj.nome}</h1>
          </div>
          <div>
            <p className="text-muted ts-14 text-nowrap">Solicitado em</p>
            <p className="ts-14 fw-bold">
              {format(new Date(requerimento.DataCriacao), 'dd/MM/yyyy')}
            </p>
          </div>
          <div>
            <p className="text-muted ts-14">Previsão</p>
            <p className="ts-14 fw-bold"> - </p>
          </div>
          <div>
            <Button
              onClick={() => {
                setIsOpenModal(true);
                setProtocol(requerimento.Protocolo);
              }}
              disabled={
                requerimento.PendenteCorrecao === 0 ||
                requerimento.anexosPendentes.length === 0 ||
                anexoEnviado
              }
            >
              Listar pendência e Regularização
            </Button>
          </div>
        </div>
      </div>

      {requerimento.Formulario !== 'SimulacaoEmprestimo' ? (
        <AnexosPendentesForm
          isOpen={isOpenModal}
          onClose={() => {
            setIsOpenModal(false);
            setProtocol('');
          }}
          onSubmit={(value) => {
            dispatch(
              enviaAnexoComplementarRequest({
                anexo: value,
                protocolo: protocol,
              })
            );

            setProtocol('');
            setIsOpenModal(false);
            setAnexoEnviado(true);
          }}
          anexosPendentes={requerimento.anexosPendentes}
        />
      ) : (
        <AnexosPendentesEmprestimoForm
          isOpen={isOpenModal}
          onClose={() => {
            setIsOpenModal(false);
            setProtocol('');
          }}
          onSubmit={(value) => {
            dispatch(
              enviaAnexoComplementarRequest({
                anexo: value,
                protocolo: protocol,
              })
            );

            setProtocol('');
            setIsOpenModal(false);
            setAnexoEnviado(true);
          }}
          anexosPendentes={requerimento.anexosPendentes}
        />
      )}
    </>
  ) : null;
};

export const PageBody = () => {
  const pendentes = useSelector(
    (state) => state.requerimento['Pendente Correção']
  );

  return (
    <>
      {pendentes.map((requerimento) => (
        <AnexoPendenteModal
          requerimento={requerimento}
          key={requerimento.Protocolo + requerimento.DataCriacao}
        />
      ))}
      {pendentes.length === 0 && (
        <div className="card">
          <div className="card-body">
            <p>Você não possui requerimentos com correções pendentes</p>
          </div>
        </div>
      )}
    </>
  );
};
